import * as React from "react";
import { ChakraProvider, Box, Heading, Text, Link } from "@chakra-ui/react";
import { Link as ReachLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Trans, useTranslation } from "react-i18next";

export function Privacy() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("privacy.metaTitle")}</title>
        <meta
          name="description"
          content={t("privacy.metaDescription")}
        />
      </Helmet>
      <ChakraProvider>
        <Box
          pt={"20px"}
          pb={8}
          textAlign="justify"
          margin={"auto"}
          width="80%"
          maxWidth={"1100px"}
        >
          <Heading
            fontFamily={"Oswald"}
            fontWeight={500}
            fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            color={"gray.800"}
            textAlign={"center"}
            mt={"20px"}
            mb={2}
          >
            {t("privacy.headingPrefix")}{" "}
            <Text as={"span"} color={"blue.500"}>
              {t("privacy.headingEmphasis")}
            </Text>
          </Heading>
          <Box mt={3}>
            <Text
              textAlign="left"
              fontFamily={"Oswald"}
              fontWeight={500}
              color="blue.400"
              mb={2}
              mt={5}
            >
              {t("privacy.sections.info.title")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.info.body1")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.info.body2")}
            </Text>
            <Text
              textAlign="left"
              fontFamily={"Oswald"}
              fontWeight={500}
              color="blue.400"
              mb={2}
              mt={7}
            >
              {t("privacy.sections.data.title")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.data.body1")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.data.body2")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.data.body3")}
            </Text>
            <Box ml={"40px"} mb={4}>
              <ul>
                <li>- {t("privacy.sections.data.list.item1")}</li>
                <li>- {t("privacy.sections.data.list.item2")}</li>
                <li>- {t("privacy.sections.data.list.item3")}</li>
                <li>- {t("privacy.sections.data.list.item4")}</li>
                <li>- {t("privacy.sections.data.list.item5")}</li>
              </ul>
            </Box>
            <Text mb={2}>
              <Trans
                i18nKey="privacy.sections.data.body4"
                components={{
                  termsLink: (
                    <Link
                      as={ReachLink}
                      to="/terms"
                      color="blue.400"
                      fontWeight={"bold"}
                    />
                  ),
                }}
              />
            </Text>
            <Text mb={2}>
              {t("privacy.sections.data.body5")}
            </Text>
            <Text
              textAlign="left"
              fontFamily={"Oswald"}
              fontWeight={500}
              color="blue.400"
              mb={2}
              mt={7}
            >
              {t("privacy.sections.social.title")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.social.body")}
            </Text>
            <Box ml={"40px"} mb={4}>
              <ul>
                <li>- {t("privacy.sections.social.list.item1")}</li>
                <li>- {t("privacy.sections.social.list.item2")}</li>
                <li>- {t("privacy.sections.social.list.item3")}</li>
                <li>- {t("privacy.sections.social.list.item4")}</li>
              </ul>
            </Box>
            <Text
              textAlign="left"
              fontFamily={"Oswald"}
              fontWeight={500}
              color="blue.400"
              mb={2}
              mt={7}
            >
              {t("privacy.sections.legal.title")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.legal.body1")}
            </Text>
            <Text mb={2}>
              {t("privacy.sections.legal.body2")}
            </Text>
          </Box>
        </Box>
      </ChakraProvider>
    </>
  );
}

export default Privacy;
